import { render, staticRenderFns } from "./ProductExpirationReport.vue?vue&type=template&id=09843ff0&"
import script from "./ProductExpirationReport.vue?vue&type=script&lang=js&"
export * from "./ProductExpirationReport.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports